import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { finalize, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services/index';
import { PipeSizeModel } from '../../../models/index';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CalculationType } from '../../../enums/calculation-type.enum';

@Component({
    selector: 'app-pipe-size',
    templateUrl: './pipe-size.component.html',
    styleUrls: ['./pipe-size.component.scss'],
})
export class PipeSizeComponent implements OnInit, OnDestroy {
    @Input()
    set form(value: UntypedFormGroup) {
        if (value) {
            this._form = value;
            if (this.router.url != '/informate/customflange/true' && this.router.url != '/informate/customflange/false') {
                this._form.get('pipeSize').setValidators(Validators.required);
            }
        }
    }
    get form(): UntypedFormGroup {
        return this._form;
    }

    @Input()
    set clampId(value: string) {
        this._clampId = value;
        if (!this.jointCalcService.isPipeCode) this.getPipeSizes(value, null);
    }
    get clampId(): string {
        return this._clampId;
    }

    @Input()
    set pressureClassId(value: string) {
        this._pressureClassId = value;
        if (!this.jointCalcService.isPipeCode) this.getPipeSizes(null, value);
    }
    get pressureClassId(): string {
        return this._pressureClassId;
    }

    @Input()
    set isCustom(value: boolean) {
        this._isCustom = value;
        if (!this.jointCalcService.isPipeCode) this.getPipeSizes(null, null);
    }
    get isCustom(): boolean {
        return this._isCustom;
    }
    @Output() selected: EventEmitter<PipeSizeModel> = new EventEmitter();
    destroy$ = new Subject();
    tooltip_position = 'above';
    loading: boolean = false;
    optionList: PipeSizeModel[];

    private _clampId: string;
    private _pressureClassId: string;
    private _isCustom: boolean;
    _form: UntypedFormGroup;

    constructor(
        private iceapi: IceapiService,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private jointCalcService: JointCalcService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.jointCalcService.pipeSizeList = [];
        this.form.markAllAsTouched();
        if (this.router.url == '/idms/plantmanager' || (this.router.url.includes('/idms/plantmanagerView') && !this.jointCalcService.isPipeCode)) {
            this.pipespecwithPressureClass();
        }
        this.form.get('pipeSize')?.valueChanges.subscribe((value) => {
            if (value) {
                if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
                    let nominalPipesize = this.optionList.find((item) => this.form.get('pipeSize').value == item.pipeSizeId)?.nominalPipeSize;
                    this.jointCalcService.pipeSpecpayload.lookupParams.nominal = nominalPipesize;
                    this.jointCalcService.selectedpipeSize.next(value);
                    this.jointCalcService.pipeSpecpayload.lookupParams.recordId.flangeTypeId = null;
                }
            }
        });
    }

    getPipeSizes(clampId: string, pressureClassId: string): void {
        this.form.markAllAsTouched();
        if (this.isCustom || (!clampId && !pressureClassId)) return;
        this.loading = true;

        this.iceapi
            .getPipeSizes(clampId, pressureClassId)
            .pipe(
                finalize(() => {
                    this.loading = false;
                })
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe((pipeSizes) => {
                if (pipeSizes.success === true) {
                    this.optionList = pipeSizes.response;
                    if (this.form.get('pipeSize').value) {
                        this.dataService.selectedPipeSize = pipeSizes.response.find((item) => this.form.get('pipeSize').value == item.pipeSizeId).pipeName;
                    }
                    if (this.optionList.length === 1) this.form.get('pipeSize').setValue(this.optionList[0].pipeSizeId, { emitEvent: true });
                    this.cd.markForCheck();
                } else {
                    this.user_utility.errorModelPopup(pipeSizes.response);
                }
            });
    }

    selectPipeSize(selectedValue: MatSelectChange): void {
        const selection = this.optionList.find((x) => x.pipeSizeId === selectedValue.value);
        if (selection) {
            this.selected.emit(selection);
            this.dataService.selectedPipeSize = selection.pipeName;
        }
        this.form.markAllAsTouched();
    }

    async pipespecwithPressureClass() {
        this.jointCalcService.selectedPressureClass.pipe(takeUntil(this.destroy$)).subscribe(async (pc) => {
            if (pc && this.jointCalcService.pipeSpecpayload.lookupParams.calculationType == CalculationType.StandardFlange) {
                let InputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;
                InputGroup.recordId.pressureClassId = pc;
                InputGroup.nominal =
                    InputGroup.recordId.flangeTypeId =
                    InputGroup.recordId.flangeFacingTypeId =
                    InputGroup.recordId.flangeMaterialId =
                    InputGroup.recordId.gasketId =
                    InputGroup.others.boltType =
                    InputGroup.recordId.boltMaterialId =
                    InputGroup.others.tighteningSpecification =
                        null;

                await this.findAndManagepipeSpecApiCall(null, pc);
            }
        });

        this.jointCalcService.selectedClampSize.pipe(takeUntil(this.destroy$)).subscribe(async (cm) => {
            if (cm) {
                const inputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;
                inputGroup.nominal =
                    inputGroup.recordId.boltMaterialId =
                    inputGroup.recordId.clampMaterialId =
                    inputGroup.recordId.pipeScheduleId =
                    inputGroup.recordId.hubMaterialId =
                    inputGroup.recordId.sealRingMaterialId =
                    inputGroup.recordId.sealRingId =
                    inputGroup.others.boltType =
                        null;
                await this.findAndManagepipeSpecApiCall(cm, null);
            }
        });
    }

    async findAndManagepipeSpecApiCall(clampId, pressureClassId) {
        this.loading = true;

        let minNominalPipeSizeObj;
        let maxNominalPipeSizeObj;

        let newList = this.jointCalcService.filterList(this.jointCalcService.pipeSpecpayload.lookupParams);

        if (this.jointCalcService.pipeSpecList?.length) {
            const minIdSet = newList.map((x) => x.minimumNominalPipeSize);
            const maxIdSet = newList.map((x) => x.maximumNominalPipeSize);

            const validMinIds = minIdSet.filter((x) => typeof x === 'number' && !isNaN(x));
            const validMaxIds = maxIdSet.filter((x) => typeof x === 'number' && !isNaN(x));

            minNominalPipeSizeObj = validMinIds.length > 0 ? Math.min(...validMinIds) : null;
            maxNominalPipeSizeObj = validMaxIds.length > 0 ? Math.max(...validMaxIds) : null;
        }

        let pipeSpecpipeSize = await this.iceapi
            .getPipeSizes(clampId, pressureClassId, minNominalPipeSizeObj ? minNominalPipeSizeObj : null, maxNominalPipeSizeObj ? maxNominalPipeSizeObj : null)
            .pipe(finalize(() => (this.loading = false)))
            .toPromise();

        if (pipeSpecpipeSize.success) {
            this.optionList = [...pipeSpecpipeSize.response];
            this.jointCalcService.pipeSizeList = this.optionList;
            if (this.optionList.length) {
                if (
                    this.dataService?.calculationData?.input?.recordId?.pipeSizeId &&
                    this.optionList.some((x) => x.pipeSizeId == this.dataService?.calculationData?.input?.recordId?.pipeSizeId)
                )
                    this.form.get('pipeSize').setValue(this.dataService?.calculationData?.input?.recordId?.pipeSizeId);
                if (this.optionList.length === 1) {
                    this.form.get('pipeSize').setValue(this.optionList[0].pipeSizeId);
                }
            }
        } else if (pipeSpecpipeSize.isCustom) {
            this.jointCalcService.pipeSizeList = [];
            this.user_utility.errorModelPopup(pipeSpecpipeSize.message);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
